<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-icon [icon]="ICON.MESSAGE" class="text-red text-4xl"></app-icon>
		<ng-container *ngIf="status === TitlePlusStatus.DECLINED">
			<p class="text-xl font-bold">Declined</p>
			<p>Your order has been declined by TitlePLUS.</p>
		</ng-container>
		<ng-container *ngIf="status === TitlePlusStatus.DELETED">
			<p class="text-xl font-bold">Deleted</p>
			<p>Your order has been deleted.</p>
		</ng-container>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button
			(click)="openPortal()"
			[icon]="ICON.RESEND"
			[testHook]="testHooks.SubmitNewOrderButton"
			>Submit new order</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-title-plus-footer [allowCancel]="false"></app-title-plus-footer>
	</div>
</div>
